import React, { useState, useEffect, useMemo } from 'react';

const includesVehicle = (vehiclesAsArray, vehicle) => {
  return vehiclesAsArray.some(
    (oldVehicle) => oldVehicle.deviceKey === vehicle.deviceKey,
  );
};

const useStateLiveVehicles = () => {
  const [stateVehicle, setStateVehicle] = useState({});
  const [vehicles, setVehicles] = useState([]);

  const addVehicleToVehicles = (addVehicle) => {
    setVehicles((p) => [...p, addVehicle]);
  };

  const handleVehicleUpdates = (updateVehicle) => {
    setVehicles((p) =>
      p.map((item) => {
        if (item.deviceKey === updateVehicle.deviceKey) {
          return {
            ...updateVehicle,
            latitude: updateVehicle.latitude,
            longitude: updateVehicle.longitude,
          };
        }
        return item;
      }),
    );
  };
  const processVehiclesChanges = (processVehicle) => {
    if (processVehicle) {
      if (Object.keys(processVehicle)?.length > 0) {
        if (!includesVehicle(vehicles, processVehicle)) {
          addVehicleToVehicles(processVehicle);
        } else {
          handleVehicleUpdates(processVehicle);
        }
      }
    }
  };

  useEffect(() => {
    processVehiclesChanges(stateVehicle);
  }, [stateVehicle]);

  return { vehicles, setStateVehicle };
};

export default useStateLiveVehicles;
